import { render, staticRenderFns } from "./order-request.vue?vue&type=template&id=42a5f05b"
import script from "./order-request.vue?vue&type=script&lang=js"
export * from "./order-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports